module.exports = __webpack_public_path__ + "static/75-52a284a94298b83b25bc039094b87b42.png";